import Http from './http';

let http = Http.Http;

// 新建账号
export const newAccount = (data) => {
	return new Promise((resolve, reject) => {
		http({
			method: 'post',
			url: '/api/admin/users',
			data
		}).then(res => {
			resolve(res)
		}).catch(err => {
			reject(err)
		})
	})
}

// 编辑账号
export const editAccount = (data) => {
	return new Promise((resolve, reject) => {
		http({
			method: 'put',
			url: `/api/admin/users/${data.id}`,
			data
		}).then(res => {
			resolve(res)
		}).catch(err => {
			reject(err)
		})
	})
}

// 删除账号
export const delAccount = (id) => {
	return new Promise((resolve, reject) => {
		http({
			method: 'delete',
			url: `/api/admin/users/${id}`
		}).then(res => {
			resolve(res)
		}).catch(err => {
			reject(err)
		})
	})
}

// 获取账户列表
export const getAccounts = (params) => {
	return new Promise((resolve, reject) => {
		http({
			method: 'get',
			url: `/api/admin/users`,
			params
		}).then(res => {
			resolve(res)
		}).catch(err => {
			reject(err)
		})
	})
}

// 获取账户信息
export const getAccountInfo = (id) => {
	return new Promise((resolve, reject) => {
		http({
			method: 'get',
			url: `/api/admin/users/${id}`,
		}).then(res => {
			resolve(res)
		}).catch(err => {
			reject(err)
		})
	})
}

// 获取登录用户信息
export const GetUserInfo = () => {
	return new Promise((resolve, reject) => {
		http({
			method: 'get',
			url: `/api/users`,
		}).then(res => {
			resolve(res)
		}).catch(err => {
			reject(err)
		})
	})
}

// 修改管理员密码
export const changePass = (data)=>{
	return new Promise((resolve, reject) => {
		http({
			method: 'put',
			url: `api/users/password?newPassword=${data.newPassword}&oldPassword=${data.oldPassword}`,
			data
		}).then(res => {
			resolve(res)
		}).catch(err => {
			reject(err)
		})
	})
}


// WEBPACK FOOTER //
// ./src/service/account.js